import useTakerMarketsGroups from '@/enterprise/data/useTakerMarketsGroups';
import { OfferModalWithContext } from '@/enterprise/features/offerModal/OfferModalContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import MarketTable from './MarketTable';

const InactiveMarketTableComponent = () => {
  const {
    INACTIVE: { takerMarkets },
  } = useTakerMarketsGroups();

  return <MarketTable includeNextMarketClearTimeCountdown={false} takerMarkets={takerMarkets} />;
};

const InactiveMarketTable = () => {
  return (
    <QueryBoundaries>
      <OfferModalWithContext>
        <InactiveMarketTableComponent />
      </OfferModalWithContext>
    </QueryBoundaries>
  );
};

export default InactiveMarketTable;
